/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Category } from '../../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    category: Category
}

const CreatedInCell: FC<Props> = ({ category }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {category.createdAt ? formatDateTime(category.createdAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
    </div>
)

export { CreatedInCell }
